/* GunLife Germany – Redesign 2026 */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  var toastEl, toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'gl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  function reveal(scope) {
    var els = $$('[data-gl-reveal]:not(.is-in)', scope);
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function tabs(scope) {
    $$('[data-gl-tabs]', scope).forEach(function (group) {
      if (group.dataset.glReady) return;
      group.dataset.glReady = '1';
      var area = group.closest('[data-gl-tabscope]') || document;
      var btns = $$('[role="tab"]', group);
      function select(btn) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          $$('[data-gl-panel="' + b.dataset.glTarget + '"]', area).forEach(function (p) { p.hidden = !on; });
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = btns[(i + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length];
          n.focus(); select(n);
        });
      });
    });
  }

  function setStock(el, available, qty, tracked) {
    if (!el) return;
    el.classList.remove('is-low', 'is-out');
    if (!available) { el.classList.add('is-out'); el.textContent = el.dataset.txtOut; return; }
    if (tracked && qty > 0 && qty <= 3) { el.classList.add('is-low'); el.textContent = el.dataset.txtLow.replace('[qty]', qty); return; }
    el.textContent = el.dataset.txtIn;
  }

  function variants(scope) {
    $$('[data-gl-variants]', scope).forEach(function (box) {
      if (box.dataset.glReady) return;
      box.dataset.glReady = '1';
      var panel = box.closest('[data-gl-product]');
      var pills = $$('[data-variant-id]', box);
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          pills.forEach(function (x) { x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
          var avail = p.dataset.available === 'true';
          var btn = $('[data-gl-add]', panel);
          if (btn) {
            btn.dataset.variantId = p.dataset.variantId;
            btn.disabled = !avail;
            var lbl = $('[data-gl-add-label]', btn);
            if (lbl) lbl.textContent = avail ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
          }
          var now = $('[data-gl-price]', panel);
          if (now) now.textContent = p.dataset.price;
          var was = $('[data-gl-compare]', panel);
          if (was) { was.textContent = p.dataset.compare || ''; was.hidden = !p.dataset.compare; }
          var img = $('.gl-stage__img', panel);
          if (img && p.dataset.image) {
            img.style.opacity = '0';
            setTimeout(function () { img.removeAttribute('srcset'); img.src = p.dataset.image; img.style.opacity = '1'; }, 180);
          }
          setStock($('[data-gl-stock]', panel), avail, parseInt(p.dataset.qty || '0', 10), p.dataset.tracked === 'true');
        });
      });
    });
  }

  function addToCart(btn) {
    var id = btn.dataset.variantId;
    if (!id) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { id: Number(id), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (!res.ok) { toast(res.data.description || res.data.message || 'Artikel konnte nicht hinzugefügt werden.'); return; }
        btn.classList.add('is-added');
        setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
        if (cart && typeof cart.renderContents === 'function' && res.data.sections) {
          cart.renderContents(res.data);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          toast('Zum Warenkorb hinzugefügt');
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gl-redesign', productVariantId: id, cartData: res.data }); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('gl:cart-updated'));
      })
      .catch(function () { btn.classList.remove('is-loading'); window.location.href = root() + 'cart'; });
  }

  function rails(scope) {
    $$('[data-gl-rail]', scope).forEach(function (rail) {
      if (rail.dataset.glReady) return;
      rail.dataset.glReady = '1';
      var track = $('[data-gl-track]', rail), prev = $('[data-gl-prev]', rail), next = $('[data-gl-next]', rail), bar = $('[data-gl-bar]', rail);
      if (!track) return;
      function step() {
        var c = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 16;
        return c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          bar.parentElement.hidden = max <= 4;
          bar.style.width = (track.clientWidth / track.scrollWidth * 100) + '%';
          bar.style.transform = 'translateX(' + (track.scrollLeft / track.clientWidth * 100) + '%)';
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function fill(el, tpl, map) {
    el.textContent = '';
    tpl.split(/(\[amount\]|\[perk\])/).forEach(function (part) {
      if (map[part] !== undefined) { var s = document.createElement('strong'); s.textContent = map[part]; el.appendChild(s); }
      else if (part) el.appendChild(document.createTextNode(part));
    });
  }

  var perksBound = false;
  function perks() {
    var boxes = $$('[data-gl-perks]');
    if (!boxes.length) return;
    function render(cart) {
      var total = cart.total_price || 0;
      boxes.forEach(function (box) {
        var tiers = $$('[data-gl-tier]', box).map(function (t) { return { el: t, min: Number(t.dataset.min) || 0 }; }).sort(function (a, b) { return a.min - b.min; });
        var top = tiers.length ? tiers[tiers.length - 1].min : 0;
        var nextTier = null;
        tiers.forEach(function (t) {
          var on = total >= t.min;
          t.el.classList.toggle('is-unlocked', on);
          var st = $('[data-gl-tier-state]', t.el);
          if (st) st.textContent = on ? box.dataset.txtOn : box.dataset.txtOff;
          if (!on && !nextTier) nextTier = t;
        });
        var f = $('[data-gl-fill]', box);
        if (f) f.style.width = (top ? Math.min(100, total / top * 100) : 100) + '%';
        var status = $('[data-gl-status]', box);
        if (status) {
          if (nextTier) fill(status, box.dataset.txtNext, { '[amount]': money(nextTier.min - total), '[perk]': nextTier.el.dataset.title });
          else { status.textContent = ''; var s = document.createElement('strong'); s.textContent = box.dataset.txtAll; status.appendChild(s); }
        }
      });
    }
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render).catch(function () {});
    if (!perksBound) {
      perksBound = true;
      document.addEventListener('gl:cart-updated', function () { perks(); });
      if (window.subscribe && window.PUB_SUB_EVENTS) { try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { perks(); }); } catch (e) {} }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gl-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    addToCart(b);
  });

  function init(scope) { scope = scope || document; reveal(scope); tabs(scope); variants(scope); rails(scope); perks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();